const s="src",t="srcset",r="sizes",e="poster",a="llOriginalAttrs",c="data";export{c as DATA,a as ORIGINALS,e as POSTER,r as SIZES,s as SRC,t as SRCSET};
